import React from 'react';
import { useDropdown } from '../Dropdown';
import { useTranslations } from 'next-intl';

export const Footer: React.FC = () => {
  const { setIsExpended, selectedItemsCount, onReset } = useDropdown();
  const tGlobal = useTranslations('Global');
  const tCatalog = useTranslations('Catalog');

  return (
    <div
      className={`
          tw-p-3
          tw-border-0
          tw-border-t
          tw-border-solid
          tw-border-blue-200
          tw-flex
          tw-row-auto
        `}
    >
      <button
        className={`
            tw-lf-button
            tw-lf-button-ghost
            tw-lf-button-md
            ${selectedItemsCount ? '' : 'tw-hidden'}
          `}
        onClick={() => onReset()}
      >
        {tCatalog('resetFilters')}
      </button>
      <button
        className={`
            tw-lf-button
            tw-lf-button-primary
            tw-lf-button-md
            tw-w-full
          `}
        onClick={() => setIsExpended(false)}
      >
        {tGlobal('close')}
      </button>
    </div>
  );
};
